/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_sip_compound_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Why doesn't my bank's quoted rate match this calculator?`)
};

const es_sip_compound_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Por qué la tasa citada de mi banco no coincide con esta calculadora?`)
};

const de_sip_compound_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Warum stimmt der zitierte Kurs meiner Bank nicht mit diesem Rechner überein?`)
};

const nl_sip_compound_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Waarom komt het geciteerde tarief van mijn bank niet overeen met deze calculator?`)
};

const fr_sip_compound_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pourquoi le taux cité par ma banque ne correspond-il pas à ce calculateur ?`)
};

const it_sip_compound_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perché il tasso quotato della mia banca non corrisponde a questo calcolatore?`)
};

const pt_br2_sip_compound_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por que a taxa citada do meu banco não corresponde a esta calculadora?`)
};

const pt_sip_compound_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Porque é que a taxa cotada do meu banco não corresponde a esta calculadora?`)
};

const ja_sip_compound_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`銀行の引用利率がこの計算機と一致しないのはなぜですか？`)
};

const zh_sip_compound_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`为什么我银行的报价利率与此计算器不匹配？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const sip_compound_faq4_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.sip_compound_faq4_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("sip_compound_faq4_q", locale)
	if (locale === "en") return en_sip_compound_faq4_q(inputs)
	if (locale === "es") return es_sip_compound_faq4_q(inputs)
	if (locale === "de") return de_sip_compound_faq4_q(inputs)
	if (locale === "nl") return nl_sip_compound_faq4_q(inputs)
	if (locale === "fr") return fr_sip_compound_faq4_q(inputs)
	if (locale === "it") return it_sip_compound_faq4_q(inputs)
	if (locale === "pt-BR") return pt_br2_sip_compound_faq4_q(inputs)
	if (locale === "pt") return pt_sip_compound_faq4_q(inputs)
	if (locale === "ja") return ja_sip_compound_faq4_q(inputs)
	return zh_sip_compound_faq4_q(inputs)
};